// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/importance_level.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/importance_level.proto.
 */
export const file_studyo_today_planners_v1_resources_importance_level = /*@__PURE__*/
  fileDesc("CjlzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL2ltcG9ydGFuY2VfbGV2ZWwucHJvdG8SInN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMqqwEKD0ltcG9ydGFuY2VMZXZlbBIgChxJTVBPUlRBTkNFX0xFVkVMX1VOU1BFQ0lGSUVEEAASHQoZSU1QT1JUQU5DRV9MRVZFTF9SRU1JTkRFUhABEhwKGElNUE9SVEFOQ0VfTEVWRUxfUkVHVUxBUhACEhoKFklNUE9SVEFOQ0VfTEVWRUxfTUFKT1IQAxIdChlJTVBPUlRBTkNFX0xFVkVMX0NSSVRJQ0FMEARCKqoCJ1N0dWR5by5Ub2RheS5QbGFubmVycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.planners.v1.resources.ImportanceLevel.
 */
export const ImportanceLevelSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_planners_v1_resources_importance_level, 0);

/**
 * Levels of importance, which can be applied to work.
 *
 * @generated from enum studyo.today.planners.v1.resources.ImportanceLevel
 */
export const ImportanceLevel = /*@__PURE__*/
  tsEnum(ImportanceLevelSchema);

